__turbopack_context__.v({
  "bannerSection": "organizers-module__VP-9jG__bannerSection",
  "baseCardClass": "organizers-module__VP-9jG__baseCardClass",
  "cardDesc": "organizers-module__VP-9jG__cardDesc",
  "cardTitle": "organizers-module__VP-9jG__cardTitle",
  "contactBtn": "organizers-module__VP-9jG__contactBtn",
  "contactDesc": "organizers-module__VP-9jG__contactDesc",
  "contactImgBkl": "organizers-module__VP-9jG__contactImgBkl",
  "contactSection": "organizers-module__VP-9jG__contactSection",
  "contactWrapper": "organizers-module__VP-9jG__contactWrapper",
  "contentWrapper": "organizers-module__VP-9jG__contentWrapper",
  "eventsBtn": "organizers-module__VP-9jG__eventsBtn",
  "featureCardTitle": "organizers-module__VP-9jG__featureCardTitle",
  "featureSection": "organizers-module__VP-9jG__featureSection",
  "featureText": "organizers-module__VP-9jG__featureText",
  "highlightTitle": "organizers-module__VP-9jG__highlightTitle",
  "percentageTitle": "organizers-module__VP-9jG__percentageTitle",
  "prizingDesc": "organizers-module__VP-9jG__prizingDesc",
  "prizingTitle": "organizers-module__VP-9jG__prizingTitle",
  "sliderBkl": "organizers-module__VP-9jG__sliderBkl",
  "sliderPrize": "organizers-module__VP-9jG__sliderPrize",
  "sliderTitle": "organizers-module__VP-9jG__sliderTitle",
  "sliderWrapper": "organizers-module__VP-9jG__sliderWrapper",
  "stepCardDesc": "organizers-module__VP-9jG__stepCardDesc",
  "stepCardNum": "organizers-module__VP-9jG__stepCardNum",
  "stepCardTitle": "organizers-module__VP-9jG__stepCardTitle",
  "stepDesc": "organizers-module__VP-9jG__stepDesc",
  "stepSection": "organizers-module__VP-9jG__stepSection",
  "stepTitle": "organizers-module__VP-9jG__stepTitle",
  "title": "organizers-module__VP-9jG__title",
  "zigzagContainer": "organizers-module__VP-9jG__zigzagContainer",
});
